module.exports = __webpack_public_path__ + "img/faq-illustration.cbca7874.svg";